import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormContext } from '@glu/validation-react';
import RouteLeavingGuard from '../routeLeavingGuard/RouteLeavingGuard';
import Prompt from '../Prompt/PromptComponent';

export default function FormPrompt({ allowNavigation, allowNavigationFunc }) {
  const form = useContext(FormContext);
  const data = get(form, 'data', {});
  const shouldBlockNavigation = (location) => {
    if (allowNavigation) {
      return false;
    }
    if (allowNavigationFunc) {
      return !allowNavigationFunc({ data, location });
    }
    return Object.values(data).some(Boolean);
  };

  return (
    <RouteLeavingGuard shouldBlockNavigation={shouldBlockNavigation}>{Prompt}</RouteLeavingGuard>
  );
}

FormPrompt.propTypes = {
  allowNavigation: PropTypes.bool,
  allowNavigationFunc: PropTypes.func
};

FormPrompt.defaultProps = {
  allowNavigation: false,
  allowNavigationFunc: null
};
